import React from 'react';

export const ShowItemsOffCanvasIcon = ({
  width = 24,
  height = 24,
  color = '#000',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10 4H14V6H10V4Z" fill={color} />
    <path d="M18 10H20V14H18V10Z" fill={color} />
    <path d="M10 18H14V20H10V18Z" fill={color} />
    <path d="M4 14V10H6V14H4Z" fill={color} />
    <path d="M5.58579 4H8V6H6V8H4V5.58579L5.58579 4Z" fill={color} />
    <path d="M18.4142 20H16V18H18V16H20V18.4142L18.4142 20Z" fill={color} />
    <path d="M4 18.4142V16H6L6 18H8L8 20H5.58579L4 18.4142Z" fill={color} />
    <path d="M20 8V5.58579L18.4142 4H16V6L18 6V8H20Z" fill={color} />
  </svg>
);
